import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import React from 'react';

import { colors } from 'src/themes/colors';

import MHButton from '../MHButton';

const useStyles = makeStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 0,
    fontFamily: 'Avenir-Black',
    fontSize: 28,
    color: colors.black4,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 24px 15px 24px',
    fontSize: 16,
    color: colors.gray8,
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: '0 24px 16px 24px',
  },
  goBackButton: {
    backgroundColor: colors.gray1,
    color: colors.black1,
    '&:hover': {
      backgroundColor: colors.gray6,
    },
  },
});

interface Props {
  clientName: string;
  joinSessionDisabled: boolean;
  onGoBack: () => void;
  onJoinSession: () => void;
  sessionStartTime: Date;
}

export const VideoPrompt: React.FC<Props> = ({
  clientName,
  joinSessionDisabled,
  onGoBack,
  onJoinSession,
  sessionStartTime,
}) => {
  const classes = useStyles();

  const startTime = moment(sessionStartTime);
  const startOffset = moment().diff(startTime, 'minutes');

  const alreadyOccurred = startOffset > 30;
  const occurringNow = startOffset < 30 && startOffset > -10;
  const notYetOccurred = startOffset < -10;

  return (
    <React.Fragment>
      <Dialog open fullWidth aria-labelledby="form-dialog-title" maxWidth="sm">
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
          {alreadyOccurred
            ? 'Session has already occurred'
            : notYetOccurred
            ? 'Session has not started yet'
            : 'Session starts now'}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography>
            This session is with <b>{clientName}</b>.
          </Typography>
          <Typography>
            It {alreadyOccurred ? 'was' : 'is'} {occurringNow ? 'starting' : 'scheduled to start'}{' '}
            at <b>{startTime.format('dddd, MMMM Do [at] LT')}</b>.
          </Typography>
        </DialogContent>
        <DialogActions className={classes.actionsContainer}>
          <MHButton
            extraClasses={[classes.goBackButton]}
            children="Go to Sessions Page"
            onClick={onGoBack}
          />
          <MHButton
            children="Join Video Session"
            onClick={onJoinSession}
            disabled={joinSessionDisabled}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
